var map = {
	"./esports-bg.webp": 1601,
	"./esports-ctg.webp": 1602,
	"./im-img.webp": 1603,
	"./im-title-cn.webp": 1604,
	"./im-title-en.webp": 1605,
	"./object-1.webp": 1606,
	"./object-2.webp": 1607,
	"./object-3.webp": 1608,
	"./object-4.webp": 1609,
	"./tfg-img.webp": 1610,
	"./tfg-title-cn.webp": 1611,
	"./tfg-title-en.webp": 1612,
	"./title-cn.webp": 1613,
	"./title-en.webp": 1614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1600;